import styled from 'styled-components'

export const Input = styled.input`
  width: 100%;
  height: 48px;
  outline: none;
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.neutral.border.strong};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  background: ${({ theme }) => theme.neutral.background.default};
  padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km3};
  color: ${({ theme }) => theme.neutral.text.strong};

  :focus-within {
    background: ${({ theme }) => theme.neutral.background.weak};
  }
  :placeholder-shown {
    border-color: ${({ theme }) => theme.neutral.border.default};
  }
  :focus {
    border-color: ${({ theme }) => theme.neutral.border.strong};
  }

  ::placeholder {
    color: ${({ theme }) => theme.neutral.text.weak};
    opacity: 1;
  }
`
